import { Board } from "@sportactics/board-editing";
import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

export function useFormationLocalPersistence(): useFormationLocalPersistenceReturn {
  return useLazyContext(FormationLocalPersistenceContext);
}

export type useFormationLocalPersistenceReturn = {
  createFormation: (name: string, formation: Board) => Promise<void>;
  listFormations: () => Promise<Record<string, Board>>;
  updateFormation: (name: string, formation: Board) => Promise<void>;
  renameFormation: (oldName: string, newName: string) => Promise<void>;
  deleteFormation: (name: string) => Promise<void>;
};

export const FormationLocalPersistenceContext =
  createContext<LazyValue<useFormationLocalPersistenceReturn>>(undefined);
